<template>
    <div class="innerPage">
         <div class="main">
             <div class="locMap">
                  <div class="loc">
                    <span>您的位置：</span>
                    <a href="javascript:void(0)">首页</a><a href="javascript:void(0)">供需对接基地</a><a href="javascript:void(0)" class="on">供应详情</a>
                </div>
             </div>
             <div class="supplierdetailShow">
                 <div class="title">{{dto.title}}</div>
                 <div class="typeShow">类型：{{dto.category_str}}</div>
                 <div class="desc">
                      {{dto.content}}
                 </div>
                 <div class="pic_show el_img_preview">
                        <el-image v-for="(item,index) in list_img" :src="utils.HandleImg(item,true)" alt="" :key="'si_'+index" :preview-src-list="[item]"></el-image>
                  </div>
                 <div class="companyInfos clearfix">
                        <div class="img">
                            <span><img :src="utils.HandleImg(dto.company_logo,false,1)"></span>
                        </div>
                       <div class="infos">
                            <div class="companyCty clearfix">
                                <span class="companyName">{{dto.company_name}}</span>
                                <span class="label">供应方</span>
                            </div>
                            <div class="time">
                                发布于：{{dto.add_time_str}}
                            </div>
                       </div>
                 </div> 
             </div>
         </div>
    </div>
</template>
<script>
import {Image} from 'element-ui'
export default {
  data(){
    return{
        id:this.$route.params.id,
        dto:{},
        list_img: [],
    }
  },
  created(){
    this.GetDetail();
  },
  components:{
      [Image.name]:Image
  },
  methods:{
   GetDetail(){
            var url = "https://api.xincailiao.com/Open/GetPurchaseDemandDetail";
            this.$http.post(url,{id:this.id}).then(function(res){
                if (res.data.status==1){
                    this.dto=res.data.ds;
                    if (this.dto.desc_pics) {
                        this.list_img = this.dto.desc_pics.split(",");
                    }
                }
            }.bind(this)).catch(function(){});
        },
  }
}
</script>
